module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Focused-Breathing-Belly-Breath.7acb681f.jpg";